<template>
  <div>
    <the-header/>
    <div class="d-flex justify-content-center">
      <blank-document/>
    </div>
    <modal :width="modalConfig.width"
           :disableHeader="true"
           :disableFooter="true">
      <template #body>
        <div class="d-flex flex-column align-items-center">
          <span class="c-6facfe mb-4">
            <i class="far fa-exclamation-circle fa-5x"/>
          </span>
          <span class="f-bold s-16 mb-2" v-if="$route && $route.params && $route.params.errorMessage">
            {{ $route.params.errorMessage }}
          </span>
          <span class="f-bold s-16 mb-2" v-else>
            No such document was found.
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      modalConfig: {
        width: 350,
      },
    };
  },
  components: {
    TheHeader: () => import('../components/TheHeader.vue'),
    BlankDocument: () => import('@/modules/validate_landing/components/BlankDocument.vue'),
    Modal: () => import('@/modules/common/components/modal/Modal.vue'),
  },
};
</script>

<style scoped>
.c-6facfe {
  color: #6facfe;
}
</style>
